import { createSlice } from "@reduxjs/toolkit";

const CHILD_INFO = {
  birthDate: "",
  gender: 0,
};

const initialState = {
  isNew: true,
  isDataChanged: false,
  reloadPage: false,
  data: {
    ethnicityCode: undefined,
    ethnicityDescription: "",
    weight: undefined,
    height: undefined,
    religionCode: undefined,
    religionTypeCode: undefined,
    skinColorCode: undefined,
    eyeColorCode: undefined,
    clothingTypeCode: undefined,
    clothingDescription: "",
    politicalOrientationCode: undefined,
    disabledDescription: "",
    specialPatientDescription: "",
    isDisabled: false,
    isSpecialPatient: false,
    isSmokingCigaret: false,
    isSmokingHookah: false,
    drugUsed: false,
    militaryServiceStatus: 5,
    artCapabilities: "",
    scienceCapabilities: "",
    musicCapabilities: "",
    sportCapabilities: "",
    otherInterests: "",
    isLivingWithChildrenDescription: "",
    marriageHistoryCode: undefined,
    residenceAbroadTypeCode: undefined,
    firstDateTypeCode: undefined,
    marriageDurationYear: "",
    marriageDurationMonth: "",
    separationDate: undefined,
    children: [],
    commitmentRateCode: undefined,
  },
};

export const PersonalInformationSlice = createSlice({
  name: "PersonalInformation",
  initialState,
  reducers: {
    updatePersonalInformationData: (state, { payload: { key, value, required } }) => {
      state.isDataChanged = true;
      state.data[key] = value;
      if (value.length === 0) {
        if (required) {
          state.data[key] = value;
        } else {
          delete state.data[key];
        }
      } else {
        state.data[key] = value;
      }
    },
    setIsDataChangedForPersonal: (state, { payload }) => {
      state.isDataChanged = payload;
    },
    setIsNewForPersonalInformation: (state, { payload }) => {
      state.isNew = payload;
    },
    setPersonalInformationData: (state, { payload }) => {
      state.isDataChanged = false;
      state.isNew = false;
      state.data = payload;
    },
    addNewChild: (state) => {
      state.isDataChanged = true;
      state.data.children.push(CHILD_INFO);
    },
    editChild: (state, { payload: { index, fieldName, value } }) => {
      state.isDataChanged = true;
      state.data.children[index][fieldName] = value;
    },
    removeChild: (state, { payload: index }) => {
      state.isDataChanged = true;
      state.data.children.splice(index, 1);
    },
    removeMaritalInfo: (state) => {
      state.isDataChanged = true;
      let maritalInfoFields = [
        "separationDate",
        "marriageDurationYear",
        "marriageDurationMonth",
        "separationDescription",
        "isLivingWithChildrenDescription",
      ];
      maritalInfoFields.forEach((field) => delete state.data[field]);
      state.data.children = [];
    },
    clearPersonalInformationData: () => initialState,
    setReloadPersonalInformationData: (state, { payload }) => {
      state.reloadPage = payload;
    },
  },
});

export const {
  setPersonalInformationData,
  setIsNewForPersonalInformation,
  updatePersonalInformationData,
  addNewChild,
  editChild,
  removeChild,
  removeMaritalInfo,
  setIsDataChangedForPersonal,
  clearPersonalInformationData,
  setReloadPersonalInformationData,
} = PersonalInformationSlice.actions;

export const PersonalInformationReducer = PersonalInformationSlice.reducer;
